// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._Yw7JwhR_3c5N10eYeT0{flex-direction:column;gap:8px;display:flex}.BLH3a_qMyiswxbSHikX7{text-align:center;width:100%;color:var(--content-primary-secondary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `_Yw7JwhR_3c5N10eYeT0`,
	"scheduleText": `BLH3a_qMyiswxbSHikX7`
};
export default ___CSS_LOADER_EXPORT___;
